module.exports = __webpack_public_path__ + "static/media/m3sblue.03bc0a02.png";